import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '@/App';
import { Button } from '@/components/ui/button';
import { ArrowLeft, LogOut, Settings, Bell } from 'lucide-react';
import { toast } from 'sonner';

function HeaderNav({ title, showBack = true }) {
  const { user, logout } = useContext(AuthContext);
  const navigate = useNavigate();

  // CORRECT FIX: Use browser's native history navigation
  // This preserves all state (filters, search, pagination) automatically
  const handleBackClick = () => {
    navigate(-1);
  };

  return (
    <div className="bg-white border-b border-slate-200 shadow-sm sticky top-0 z-10">
      <div className="max-w-7xl mx-auto px-4 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3">
            {showBack && (
              <Button variant="ghost" size="icon" onClick={handleBackClick} data-testid="back-button">
                <ArrowLeft className="h-5 w-5" />
              </Button>
            )}
            <div>
              <h1 className="text-2xl font-bold text-slate-800" style={{ fontFamily: 'Manrope' }}>
                {title}
              </h1>
              <p className="text-sm text-slate-600">{user?.full_name}</p>
            </div>
          </div>
          <div className="flex items-center gap-2">
            <Button variant="outline" size="icon" onClick={() => toast.info('Notifications feature coming soon!')} data-testid="notifications-button">
              <Bell className="h-5 w-5" />
            </Button>
            <Button variant="outline" onClick={() => navigate('/settings')} data-testid="settings-button">
              <Settings className="mr-2 h-4 w-4" />
              Settings
            </Button>
            <Button variant="ghost" size="icon" onClick={logout} data-testid="logout-button">
              <LogOut className="h-5 w-5" />
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default HeaderNav;
